import { gql } from '@apollo/client'

export const COMPANIES_QUERY = gql`
  query companies($sortBy: CompanySort, $filter: CompanyFilter, $page: Int, $limit: Int) {
    companies(sortBy: $sortBy, filter: $filter, page: $page, limit: $limit) {
      collection {
        id
        company
        title
        street
        houseNumber
        postalCode
        place
        country
        email
        phoneNumber
        mobileNumber
        archived
      }
      metadata {
        totalCount
      }
    }
  }
`
